<template>
  <div class="pt-panel industrial-info-panel">
    <div class="pt-header">
      <div class="pt-header-text">
        <div class="pt-kicker">工程信息</div>
        <h2 class="pt-title">{{ oneTitle }}</h2>
        <p class="pt-subtitle">工业园区用水指标 · 实时数据</p>
      </div>
      <button class="pt-close" @click="closeClick">&times;</button>
    </div>

    <div class="pt-flex-table">
      <div class="pt-flex-table-header">
        <div class="pt-flex-table-cell">项目</div>
        <div class="pt-flex-table-cell">内容</div>
      </div>
      <div
          class="pt-flex-table-row"
          v-for="(item, index) in parkInfo"
          :key="index"
      >
        <div class="pt-flex-table-cell">{{ item.label }}</div>
        <div class="pt-flex-table-cell">{{ item.value }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "industrialParkInfo",
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      oneTitle: "",
      parkInfo: [],
    };
  },
  mounted() {
    this.updateData();
  },
  watch: {
    info: {
      handler(val) {
        this.oneTitle = val.name
      },
      immediate: true
    },
  },
  methods: {
    updateData() {
      this.parkInfo = [
        { label: "年用水总量", value: `${(Math.random() * (900 - 650) + 650).toFixed(1)} 万 m³` },
        { label: "日均用水量", value: `${(Math.random() * (2.5 - 1.5) + 1.5).toFixed(2)} 万 m³` },
        { label: "再生水利用率", value: `${(Math.random() * (90 - 75) + 75).toFixed(1)} %` },
        { label: "废水回用率", value: `${(Math.random() * (95 - 80) + 80).toFixed(1)} %` },
      ];
    },

    closeClick() {
      this.$emit("infoClose");
    },
  },
};
</script>

<style scoped>
.industrial-info-panel {
  width: 45%;
  height: 65%;
  position: absolute;
  overflow-y: auto;
  max-height: 65%;
  left: 30%;
  top: 200px;
}
</style>
